import { useState } from 'react';
import { v4 as uuid } from 'uuid';
import {
  ButtonSecondary,
  ButtonSize,
  IconDown,
  IconExpand,
  IconUp,
} from '@ui/src';
import { ExpectedFundsOriginsTypes } from '../types';
import { ExpectedFundsOriginsFormValues } from '../../../../hoc/new-application/types';
import ExpectedFundsOriginsContent from './expected-funds-origins-content';

import cn from '../styles.module.css';

const ExpectedFundsOrigins = ({
  status,
  isEditable,
  currencies,
  deleteExpectedFundsOriginsInProgress,
  onDeleteExpectedFundsOrigins,
  selectedExpectedFundsOriginsId,
  expectedFundsOriginsValues,
  expectedFundsOriginsValuesList,
  setExpectedFundsOriginsValues,
  type,
  countries,
}: ExpectedFundsOriginsTypes) => {
  const [expanded, setExpanded] = useState(true);

  return (
    <div className={cn.expectedFundsOriginsWrapper}>
      <div>
        <button
          type="button"
          className={cn.expectedFundsOriginsTitle}
          onClick={() => setExpanded(!expanded)}
        >
          {expanded ? <IconUp /> : <IconDown />}
          {`${type.charAt(0)}${type.slice(1).toLowerCase()} funds (${type === 'INCOMING' ? 'credited' : 'debited'} to the account)`}
        </button>
      </div>
      {expanded && (
        <>
          {expectedFundsOriginsValues &&
            expectedFundsOriginsValues?.length > 0 &&
            expectedFundsOriginsValues?.map((item, index) => (
              <ExpectedFundsOriginsContent
                key={item.id}
                status={status}
                isEditable={isEditable}
                currencies={currencies}
                deleteExpectedFundsOriginsInProgress={
                  deleteExpectedFundsOriginsInProgress
                }
                onDeleteExpectedFundsOrigins={onDeleteExpectedFundsOrigins}
                selectedExpectedFundsOriginsId={selectedExpectedFundsOriginsId}
                expectedFundsOrigin={item}
                setExpectedFundsOriginsValues={setExpectedFundsOriginsValues}
                expectedFundsOrigins={expectedFundsOriginsValuesList}
                index={index}
                countries={countries}
              />
            ))}
          <ButtonSecondary
            size={ButtonSize.SMALL}
            className={`${cn.addAccountCurrencyButton} button-white`}
            icon={<IconExpand />}
            text="Add Counterparties"
            onClick={() => {
              let nextExpectedfundsOrigins: ExpectedFundsOriginsFormValues[] =
                [];

              if (expectedFundsOriginsValuesList) {
                nextExpectedfundsOrigins = (
                  [] as ExpectedFundsOriginsFormValues[]
                ).concat(expectedFundsOriginsValuesList);
              }

              nextExpectedfundsOrigins.push({
                id: `expected-funds-origins-${uuid()}`,
                currencyId: '',
                mainCounterpartiesAndWebsites: '',
                countryOfIncorporationId: '',
                counterpartyBankCountryIds: [],
                activityCountryIds: [],
                mainActivities: '',
                transactionReason: '',
                transactionType: type,
              });

              setExpectedFundsOriginsValues(nextExpectedfundsOrigins);
            }}
          />
        </>
      )}
    </div>
  );
};

export default ExpectedFundsOrigins;
